export default function logError(...details) {
  if (process.env.DEBUG) console.error(...details);

  // client side only
  if (typeof window !== 'undefined') window['newrelic']?.noticeError(...details);
}
